import React, { useEffect, useState } from "react";
import CivilianForm from "../components/CivilianFrom";
import DefenceOfficer from "../components/DefenceOfficer";
import ForeignerForm from "../components/ForeignerFrom";
import CorporateForm from "../components/CorporateForm";
import { useSearchParams } from "react-router-dom";

const MembershipRegistration = () => {
  const [searchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formikProps, setFormikProps] = useState({
    category: "Select Category of Applicant",
  });

  // Direct mapping from URL categories to form categories
  // const categoryMapping = {
  //   MILITARY: "MILITARY",
  //   "SERVING GOVERNMENT OFFICERS": "SERVING_GOVT_OFFICER",
  //   CIVILIANS: "CIVILIAN",
  //   "FOREIGNERS/DIPLOMATS": "FOREIGNERS_DIPLOMATS",
  //   "NON-GOVERNMENT ORGANIZATIONS/AGENCY": "NON_GOVERNMENT_ORGANIZATION_AGENCY",
  // };
  const categoryMapping = {
    MILITARY: "Military",
    "SERVING GOVERNMENT OFFICERS": "Serving Govt Officer",
    CIVILIANS: "Civilian",
    "FOREIGNERS/DIPLOMATS": "Foreigners/Diplomats",
    "NON-GOVERNMENT ORGANIZATIONS/AGENCY": "Non-government Organization/Agency",
  };

  // Map for dropdown display
  // const displayCategoryMapping = {
  //   MILITARY: "Military",
  //   SERVING_GOVT_OFFICER: "Serving Govt Officer",
  //   CIVILIAN: "Civilian",
  //   FOREIGNERS_DIPLOMATS: "Foreigners/Diplomats",
  //   NON_GOVERNMENT_ORGANIZATION_AGENCY: "Non-government Organization/Agency",
  // };

  const displayCategoryMapping = {
    Military: "Military",
    "Serving Govt Officer": "Serving Govt Officer",
    Civilian: "Civilian",
    "Foreigners/Diplomats": "Foreigners/Diplomats",
    "Non-government Organization/Agency": "Non-government Organization/Agency",
  };

  // useEffect(() => {
  //   // Get category from URL parameters
  //   const categoryFromUrl = searchParams.get("category");

  //   if (categoryFromUrl) {
  //     // Map the URL category to the appropriate enum value
  //     const mappedCategory = categoryMapping[categoryFromUrl];

  //     if (mappedCategory) {
  //       // Set the display category for the dropdown
  //       const displayCategory = displayCategoryMapping[mappedCategory];

  //       setSelectedCategory(mappedCategory);
  //       setFormikProps((prev) => ({
  //         ...prev,
  //         category: displayCategory,
  //         categoryEnum: mappedCategory, // Store enum value for form submission
  //       }));
  //     }
  //   }
  // }, [searchParams]);

  useEffect(() => {
    // Get category from URL parameters
    const categoryFromUrl = searchParams.get("category");

    if (categoryFromUrl) {
      // Map the URL category to the appropriate display label
      const displayCategory = categoryMapping[categoryFromUrl];

      if (displayCategory) {
        setSelectedCategory(displayCategory);
        setFormikProps((prev) => ({
          ...prev,
          category: displayCategory,
          categoryForBackend: displayCategory, // This should be the display label
        }));
      }
    }
  }, [searchParams]);

  const handleCategoryChange = (e) => {
    // const category = e.target.value;

    // setFormikProps((prev) => ({ ...prev, category }));

    // // Only set selectedCategory if it's a valid selection (not the default)
    // if (category !== "Select Category of Applicant") {
    //   setSelectedCategory(category);
    // } else {
    //   setSelectedCategory(null);
    // }
    // const displayCategory = e.target.value;

    // // Find the enum value for the selected display category
    // const enumValue = Object.entries(displayCategoryMapping).find(
    //   ([enumVal, displayVal]) => displayVal === displayCategory
    // )?.[0];

    // setFormikProps((prev) => ({
    //   ...prev,
    //   category: displayCategory,
    //   categoryEnum: enumValue,
    // }));

    // if (displayCategory !== "Select Category of Applicant" && enumValue) {
    //   setSelectedCategory(enumValue);
    // } else {
    //   setSelectedCategory(null);
    // }

    const displayCategory = e.target.value;

    setFormikProps((prev) => ({
      ...prev,
      category: displayCategory,
      categoryForBackend: displayCategory, // Use display label for backend
    }));

    if (displayCategory !== "Select Category of Applicant") {
      setSelectedCategory(displayCategory);
    } else {
      setSelectedCategory(null);
    }
  };

  // const renderForm = () => {
  //   switch (selectedCategory) {
  //     case "Non Military":
  //     case "Government Officer":
  //       return <CivilianForm {...formikProps} />;
  //     case "Serving Defence Officer":
  //     case "Retired Defence Officer":
  //       return <DefenceOfficer {...formikProps} />;
  //     case "Foreigner/Diplomat":
  //       return <ForeignerForm {...formikProps} />;
  //     case "Corporate/Business":
  //       return <CorporateForm {...formikProps} />;
  //     default:
  //       return null;
  //   }
  // };

  // const renderForm = () => {
  //   // Use the enum values directly
  //   switch (selectedCategory) {
  //     case "MILITARY":
  //       return <DefenceOfficer {...formikProps} />;
  //     case "SERVING_GOVT_OFFICER":
  //       return <CivilianForm {...formikProps} />;
  //     case "CIVILIAN":
  //       return <CivilianForm {...formikProps} />;
  //     case "FOREIGNERS_DIPLOMATS":
  //       return <ForeignerForm {...formikProps} />;
  //     case "NON_GOVERNMENT_ORGANIZATION_AGENCY":
  //       return <CorporateForm {...formikProps} />;
  //     default:
  //       return null;
  //   }
  // };

  const renderForm = () => {
    // Use the display labels directly
    switch (selectedCategory) {
      case "Military":
        return <DefenceOfficer {...formikProps} />;
      case "Serving Govt Officer":
        return <CivilianForm {...formikProps} />;
      case "Civilian":
        return <CivilianForm {...formikProps} />;
      case "Foreigners/Diplomats":
        return <ForeignerForm {...formikProps} />;
      case "Non-government Organization/Agency":
        return <CorporateForm {...formikProps} />;
      default:
        return null;
    }
  };

  // Update the dropdown options to use new categories
  const dropdownOptions = [
    { value: "Military", label: "Military" },
    { value: "Serving Govt Officer", label: "Serving Govt Officer" },
    { value: "Civilian", label: "Civilian" },
    { value: "Foreigners/Diplomats", label: "Foreigners/Diplomats" },
    {
      value: "Non-government Organization/Agency",
      label: "Non-government Organization/Agency",
    },
  ];

  return (
    <div className="bg-gradient-to-b from-gray-50 to-[#fffdf7] min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-lime-100 to-lime-200 rounded-full mb-6 shadow-lg">
            <svg
              className="w-10 h-10 text-lime-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              />
            </svg>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 to-lime-800 bg-clip-text text-transparent mb-4">
            Membership Registration
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Begin your journey with us by selecting your applicant category
            below
          </p>
        </div>

        {/* Category Selection Card */}
        <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 mb-12 border border-gray-100">
          <div className="space-y-8">
            {/* <div>
              <div className="flex items-center mb-4">
                <div className="w-2 h-8 bg-gradient-to-b from-lime-500 to-lime-600 rounded-full mr-3"></div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Select Your Membership Category
                </h2>
              </div>
              <p className="text-gray-600 mb-6">
                Choose the category that best describes your current status
              </p>

              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="w-6 h-6 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <select
                  id="category"
                  name="category"
                  value={formikProps.category}
                  onChange={handleCategoryChange}
                  className="pl-12 pr-10 py-4 text-lg rounded-xl border-2 border-gray-200 bg-gray-50 w-full outline-none focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition-all duration-200 appearance-none"
                >
                  <option disabled value="Select Category of Applicant">
                    Select Category of Applicant
                  </option>
                  <option
                    value="Serving Defence Officer"
                    className="py-3 hover:bg-lime-50"
                  >
                    Serving Defence Officer
                  </option>
                  <option
                    value="Retired Defence Officer"
                    className="py-3 hover:bg-lime-50"
                  >
                    Retired Defence Officer
                  </option>
                  <option
                    value="Government Officer"
                    className="py-3 hover:bg-lime-50"
                  >
                    Government Officer
                  </option>
                  <option
                    value="Non Military"
                    className="py-3 hover:bg-lime-50"
                  >
                    Non Military
                  </option>
                  <option
                    value="Corporate/Business"
                    className="py-3 hover:bg-lime-50"
                  >
                    Corporate/Business
                  </option>
                  <option
                    value="Foreigner/Diplomat"
                    className="py-3 hover:bg-lime-50"
                  >
                    Foreigner/Diplomat
                  </option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div> */}
            {/* <div>
              <div className="flex items-center mb-4">
                <div className="w-2 h-8 bg-gradient-to-b from-lime-500 to-lime-600 rounded-full mr-3"></div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Select Your Membership Category
                </h2>
              </div>
              <p className="text-gray-600 mb-6">
                Choose the category that best describes your current status
              </p>

              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="w-6 h-6 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <select
                  id="category"
                  name="category"
                  value={formikProps.category}
                  onChange={handleCategoryChange}
                  className="pl-12 pr-10 py-4 text-lg rounded-xl border-2 border-gray-200 bg-gray-50 w-full outline-none focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition-all duration-200 appearance-none"
                >
                  <option disabled value="Select Category of Applicant">
                    Select Category of Applicant
                  </option>
                  {dropdownOptions.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      className="py-3 hover:bg-lime-50"
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div> */}

            {/* Selected Category Indicator */}
            {/* {selectedCategory && (
              <div className="bg-gradient-to-r from-lime-50 to-emerald-50 border border-lime-200 rounded-xl p-6 transform transition-all duration-300">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-gradient-to-br from-lime-500 to-lime-600 rounded-lg p-3 shadow-md">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">
                      Selected Category
                    </h3>
                    <div className="flex items-center">
                      <span className="text-xl font-bold text-lime-700 bg-lime-100 px-3 py-1 rounded-lg">
                        {selectedCategory}
                      </span>
                      <div className="ml-4 flex items-center text-sm text-gray-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span>Ready to proceed</span>
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm mt-3">
                      You've selected{" "}
                      <span className="font-semibold">{selectedCategory}</span>.
                      Please fill out the form below with accurate information.
                    </p>
                  </div>
                </div>
              </div>
            )} */}
            {selectedCategory && (
              <div className="bg-gradient-to-r from-lime-50 to-emerald-50 border border-lime-200 rounded-xl p-6 transform transition-all duration-300">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-gradient-to-br from-lime-500 to-lime-600 rounded-lg p-3 shadow-md">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">
                      Selected Category
                    </h3>
                    <div className="flex items-center">
                      <span className="text-xl font-bold text-lime-700 bg-lime-100 px-3 py-1 rounded-lg">
                        {formikProps.category}
                      </span>
                      <div className="ml-4 flex items-center text-sm text-gray-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span>Ready to proceed</span>
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm mt-3">
                      You've selected{" "}
                      <span className="font-semibold">
                        {formikProps.category}
                      </span>
                      . Please fill out the form below with accurate
                      information.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Category Information Cards */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-6 border-t border-gray-100">
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="flex items-center mb-2">
                  <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                  <span className="text-sm font-medium text-gray-700">
                    Defence Officers
                  </span>
                </div>
                <p className="text-xs text-gray-600">
                  Serving and retired military personnel
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="flex items-center mb-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                  <span className="text-sm font-medium text-gray-700">
                    Civilian Categories
                  </span>
                </div>
                <p className="text-xs text-gray-600">
                  Government, corporate, and non-military applicants
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="flex items-center mb-2">
                  <div className="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
                  <span className="text-sm font-medium text-gray-700">
                    International
                  </span>
                </div>
                <p className="text-xs text-gray-600">
                  Foreign nationals and diplomats
                </p>
              </div>
            </div> */}
          </div>
        </div>

        {/* Form Container with Animation */}
        <div
          className={`transition-all duration-700 ease-out ${
            selectedCategory
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          {selectedCategory && (
            <>
              {/* Form Header */}
              <div className="mb-8">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-2 h-10 bg-gradient-to-b from-lime-500 to-lime-600 rounded-full mr-3"></div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                      {/* {selectedCategory} Registration Form */}
                      {formikProps.category} Registration Form{" "}
                      {/* Use formikProps.category */}
                    </h2>
                  </div>
                  <div className="hidden md:flex items-center text-sm text-gray-600 bg-lime-50 px-4 py-2 rounded-full">
                    <svg
                      className="w-4 h-4 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    Most fields are required, please fill them carefully.
                  </div>
                </div>
                <div className="bg-gradient-to-r from-lime-100 to-transparent p-4 rounded-xl border border-lime-200">
                  <p className="text-gray-700">
                    Complete the following form with accurate information.
                    Ensure all required documents are ready for upload. This
                    information will be used for your membership application.
                  </p>
                </div>
              </div>

              {/* Render Form */}
              <div className="transform transition-all duration-500">
                {renderForm()}
              </div>

              {/* Back to Category Selection */}
              <div className="mt-12 text-center">
                <button
                  onClick={() => {
                    setSelectedCategory(null);
                    setFormikProps({
                      category: "Select Category of Applicant",
                    });
                  }}
                  className="inline-flex items-center text-gray-600 hover:text-gray-900 hover:bg-gray-100 px-6 py-3 rounded-xl font-medium transition duration-200"
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Change Category
                </button>
              </div>
            </>
          )}
        </div>

        {/* Instructions when no category selected */}
        {!selectedCategory && (
          <div className="text-center py-16">
            <div className="max-w-2xl mx-auto">
              <div className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg
                  className="w-12 h-12 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-700 mb-3">
                Select a Category to Begin
              </h3>
              <p className="text-gray-600 mb-6">
                Choose your applicant category from the dropdown above to access
                the appropriate registration form
              </p>
              <div className="flex items-center justify-center text-gray-500">
                <svg
                  className="w-5 h-5 mr-2 animate-bounce"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                  />
                </svg>
                <span>Select a category above</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipRegistration;
